import { Dropzone, FileStatus } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface DropzoneComponentProps {
  fileStatus: FileStatus | null
  setFileStatus: React.Dispatch<React.SetStateAction<FileStatus | null>>
}

interface FileError {
  message: string
  code: string
}

const DropzoneComponent = ({
  fileStatus,
  setFileStatus,
}: DropzoneComponentProps) => {
  const { t } = useTranslation()
  const [filePreview, setFilePreview] = useState<string | null>(null)

  const handleFileStatusChange = (status: FileStatus) => {
    setFileStatus(status)
    if (status.files && status.hasFile) {
      if (status.files[0].type.startsWith("image/")) {
        const previewUrl = URL.createObjectURL(status.files[0])
        setFilePreview(previewUrl)
      } else {
        setFilePreview(null)
      }
    } else {
      setFilePreview(null)
    }
  }

  useEffect(() => {
    return () => {
      if (filePreview) {
        URL.revokeObjectURL(filePreview)
      }
    }
  }, [filePreview])

  return (
    <div>
      {!fileStatus?.hasFile ? (
        <Dropzone
          maxFiles={1}
          multiple={false}
          onFileStatusChange={handleFileStatusChange}
          accept={{
            "image/png": [".jpg", ".jpeg", ".png", ".svg"],
          }}
        />
      ) : (
        <div>
          <div>
            {fileStatus &&
              fileStatus.errors &&
              fileStatus.errors.length > 0 && (
                <div className='tw-mt-2 tw-text-red-500 tw-bg-red-50 tw-p-2 tw-rounded'>
                  <p className='tw-font-bold'>{t("newDoc.msg.errorText")}</p>
                  <ul className='tw-list-disc tw-pl-5'>
                    {fileStatus?.errors.map((error: FileError) => (
                      <li key={error.message}>{error.message}</li>
                    ))}
                  </ul>
                </div>
              )}
          </div>

          {fileStatus && fileStatus.hasFile && fileStatus.files && (
            <div className='tw-mt-4 tw-p-4 tw-border tw-rounded tw-bg-gray-100'>
              {filePreview && (
                <div className='tw-w-fit tw-relative'>
                  <img
                    src={filePreview}
                    alt={fileStatus.files[0].name}
                    className='tw-max-w-full tw-max-h-48 tw-object-contain tw-border tw-p-2 tw-bg-white'
                  />
                  <span
                    className='tw-absolute -tw-top-2 -tw-right-2 tw-flex tw-justify-center tw-items-center tw-p-1 tw-rounded-full tw-bg-danger-10 hover:tw-shadow-md tw-cursor-pointer'
                    onClick={() => {
                      setFilePreview(null)
                      setFileStatus(null)
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["fal", "xmark"]}
                      className='tw-text-danger tw-w-3 tw-h-3 tw-cursor-pointer'
                    />
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default DropzoneComponent
